import { render, staticRenderFns } from "./VaricoseVeinPage.vue?vue&type=template&id=09c199ff&scoped=true"
import script from "./VaricoseVeinPage.vue?vue&type=script&lang=js"
export * from "./VaricoseVeinPage.vue?vue&type=script&lang=js"
import style0 from "./VaricoseVeinPage.vue?vue&type=style&index=0&id=09c199ff&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09c199ff",
  null
  
)

export default component.exports